import type { CityConfig } from "@/pages/city-template/types";

export const whitePlainsConfig: CityConfig = {
  city: "White Plains",
  state: "New York",
  stateAbbr: "NY",
  slug: "white-plains",
  route: "/cities/white-plains",
  title: "Emergency & Expedited Passport White Plains NY | Same Day Passport Services",
  metaDescription:
    "Emergency passport White Plains NY — same day, 24-hour, and 3-5 day expedited passport processing for Westchester County. Fast Passport Center serves White Plains, Harrison, Rye, Scarsdale, and all Westchester communities.",
  h1: "Emergency & Expedited Passport Services in White Plains, NY",
  heroSubtitle:
    "White Plains' fast passport solution — Westchester County's premier business hub. Whether you're flying out of Westchester County Airport or JFK, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20White%20Plains%20New%20York%20downtown%20skyline%20with%20modern%20office%20buildings%2C%20Westchester%20County%20Courthouse%2C%20suburban%20Westchester%20landscape%20in%20background%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20upscale%20New%20York%20suburban%20cityscape%20with%20tree-lined%20streets&width=1600&height=700&seq=ny-white-plains-hero-001&orientation=landscape",
  heroImageAlt: "White Plains New York downtown skyline with Westchester County buildings at golden hour",
  geoPosition: "41.0349; -73.7629",
  geoPlacename: "White Plains, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~28 miles (South in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "White Plains", zips: "10601, 10602, 10603, 10605, 10606, 10607, 10610" },
    { name: "Harrison", zips: "10528, 10577" },
    { name: "Rye", zips: "10580" },
    { name: "Scarsdale", zips: "10583" },
    { name: "New Rochelle", zips: "10801, 10802, 10804, 10805" },
    { name: "Yonkers", zips: "10701, 10703, 10704, 10705, 10706, 10707, 10708, 10709, 10710" },
    { name: "Mount Vernon", zips: "10550, 10551, 10552, 10553" },
    { name: "Greenwich (CT)", zips: "06830, 06831, 06836, 06870, 06878" },
    { name: "Stamford (CT)", zips: "06901, 06902, 06903, 06904, 06905, 06906, 06907, 06910, 06911, 06912, 06914, 06926, 06927" },
    { name: "Port Chester", zips: "10573" },
    { name: "Mamaroneck", zips: "10543, 10538" },
    { name: "Larchmont", zips: "10538" },
    { name: "Bronxville", zips: "10708" },
    { name: "Tuckahoe", zips: "10707" },
    { name: "Eastchester", zips: "10709" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for White Plains travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for White Plains residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Westchester County",
      desc: "White Plains, Harrison, Rye, Scarsdale, and all of Westchester — we serve the entire county plus bordering Fairfield County, CT.",
    },
  ],
  testimonials: [
    {
      name: "Richard M.",
      location: "Harrison, NY",
      rating: 5,
      text: "Had a last-minute business trip to London. Fast Passport Center got my expedited passport processed in 4 days. They coordinated with the acceptance clerk in White Plains seamlessly.",
      service: "Expedited Passport",
    },
    {
      name: "Sarah K.",
      location: "Scarsdale, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 3. Excellent service for busy Westchester professionals.",
      service: "Passport Renewal",
    },
    {
      name: "David L.",
      location: "Rye, NY",
      rating: 5,
      text: "First-time passport for my family vacation to Italy. The agent walked us through the entire process and found us a convenient acceptance facility in White Plains.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "white-plains-1",
      name: "White Plains Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "100 Fisher Avenue",
      city: "White Plains",
      state: "NY",
      zip: "10601",
      phone: "914-761-6474",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown White Plains",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Westchester passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "white-plains-2",
      name: "Westchester County Clerk",
      type: "County Clerk / Passport Acceptance Facility",
      address: "110 Dr Martin Luther King Jr Boulevard",
      city: "White Plains",
      state: "NY",
      zip: "10601",
      phone: "914-995-3080",
      hours: "Mon-Fri 9:00 AM - 5:00 PM",
      distance: "White Plains Government Center",
      website: "https://www.westchester.gov",
      websiteLabel: "Westchester County",
      notes: "Passport acceptance services available by appointment. Convenient for downtown White Plains residents and professionals.",
      icon: "ri-building-2-line",
    },
    {
      id: "white-plains-3",
      name: "Mamaroneck Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "222 Boston Post Road",
      city: "Mamaroneck",
      state: "NY",
      zip: "10543",
      phone: "914-698-4800",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Mamaroneck (south of White Plains)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Mamaroneck, Larchmont, and south White Plains communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in White Plains?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for White Plains residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in White Plains?",
      a: "The White Plains Main Post Office at 100 Fisher Avenue is the major Westchester passport acceptance facility. The Westchester County Clerk at 110 Dr Martin Luther King Jr Boulevard also offers passport services by appointment. The Mamaroneck Post Office at 222 Boston Post Road is another convenient option for south White Plains residents.",
    },
    {
      q: "Can I get same-day passport photos in White Plains?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout White Plains and Westchester County including Harrison, Rye, and Scarsdale. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in White Plains?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your White Plains passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in White Plains?",
      a: "The fastest way to renew a passport in White Plains is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in White Plains?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in White Plains and all Westchester County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in White Plains?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in White Plains. We serve Westchester County and all surrounding areas through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — White Plains", address: "various CVS locations across White Plains, Harrison, Rye, and Scarsdale", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — White Plains", address: "various Walgreens locations throughout White Plains and Westchester County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — White Plains", address: "various UPS Store locations in White Plains and Harrison", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — White Plains", address: "various FedEx Office locations across White Plains", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — White Plains", address: "various Walmart locations in Westchester County", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — White Plains",
      address: "200 Hamilton Avenue, White Plains, NY 10601",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "White Plains DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Yonkers",
      address: "1 Larkin Plaza, Yonkers, NY 10701",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Yonkers DMV office serving south White Plains, Yonkers, and Mount Vernon residents.",
      featured: false,
    },
    {
      name: "NYS DMV — New Rochelle",
      address: "28 Huntington Avenue, New Rochelle, NY 10801",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "New Rochelle DMV office serving east White Plains, New Rochelle, and Mamaroneck communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "HPN",
      name: "Westchester County Airport",
      distance: "~5 miles from White Plains",
      address: "240 Airport Road, White Plains, NY 10604",
      note: "Westchester's primary airport with flights to major U.S. hubs. Perfect for White Plains and Westchester County travelers.",
      flightUrl: "https://airport.westchestergov.com/",
      flightLabel: "HPN Airport",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~28 miles from White Plains",
      address: "JFK Access Road, Jamaica, NY 11430",
      note: "Major international hub with flights worldwide. The closest major international airport for White Plains residents.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~22 miles from White Plains",
      address: "Flushing, NY 11371",
      note: "Convenient for domestic flights and some international destinations. Popular alternative for Westchester County travelers.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LGA Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For White Plains travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for White Plains residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for White Plains residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for White Plains residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in White Plains, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for White Plains residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for White Plains travelers with immediate departure needs from Westchester County Airport or JFK." },
    { name: "Passport Renewal", description: "Fast passport renewal for White Plains residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for White Plains residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for White Plains residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in White Plains and Westchester County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in White Plains." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many White Plains travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many White Plains travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our White Plains team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your White Plains address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Mount Vernon", route: "/cities/mount-vernon" },
    { name: "Tarrytown", route: "/cities/tarrytown" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves White Plains and all of Westchester County as a remote courier service. We do not have a physical office in White Plains, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — White Plains area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to White Plains and all of Westchester County. From downtown White Plains to the Sound Shore, from Harrison to Rye — we serve the entire county with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve White Plains and all surrounding communities across Westchester County and bordering Fairfield County, Connecticut. Whether you're in Harrison, Scarsdale, or New Rochelle, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our White Plains customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes White Plains travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "White Plains and Westchester County travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in White Plains. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default whitePlainsConfig;